import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ObtenerPorcentajeUsuariosPorRolService } from '../../../../application/administrador/services/obtener-porcentaje-usuarios-por-rol.service';
import { UsuariosRol } from './usuarios-rol';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-widget-distribucion-roles',
  templateUrl: './widget-distribucion-roles.component.html',
  styleUrl: './widget-distribucion-roles.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WidgetDistribucionRolesComponent implements OnInit {
  usuariosPorRol: UsuariosRol[] = [];
  cargando: boolean = true;

  constructor(
    private obtenerPorcentajeUsuariosPorRolService: ObtenerPorcentajeUsuariosPorRolService,
    private toastrService: ToastrService,
  ) {}

  ngOnInit() {
    this.obtenerPorcentajeUsuariosPorRol();
  }

  public obtenerPorcentajeUsuariosPorRol() {
    this.obtenerPorcentajeUsuariosPorRolService.__invoke().subscribe({
      next: (usuariosRol) => {
        this.usuariosPorRol = usuariosRol;
        this.cargando = false;
      },
      error: (error) => {
        this.toastrService.error('Error al cargar distribución por rol.');
        this.cargando = false;
      },
    });
  }

  public obtenerDescripcionRol(rol: string) {
    switch (rol) {
      case '1':
        return 'Administrador';
      default:
        return 'Usuario';
    }
  }

  public obtenerColorRol(rol: string) {
    switch (rol) {
      case '1':
        return 'bg-blue-200';
      default:
        return 'bg-green-200';
    }
  }
}
